import React from 'react';
import '../styles/components/photo.scss'

const Photo = () => {
    return (
        <div className='Img-moi'></div>
    );
};

export default Photo;